import {
  ChatterOverviewComparison,
  ChatterOverviewSales,
  ChatterOverviewStatistics,
  ChatterPerformance,
} from '@/model/analytics'
import { createAppAsyncThunk } from '@/redux/utils'
import { axios } from '@/utils/axios'

import { selectFeatureTimezone } from './global-selector'

export const chatterReportsNamespace = 'chatterReports'

export interface ReadChatterReportParams {
  startAt?: Date
  endAt?: Date
  period?: string
  permissionKey?: string
  employeeIds?: number[]
  groupIds?: number[]
}

export const readChatterOverviewSales = createAppAsyncThunk(
  `${chatterReportsNamespace}/readChatterOverviewSales`,
  async (
    {
      startAt,
      endAt,
      employeeIds,
      groupIds,
      period,
      permissionKey,
    }: ReadChatterReportParams = {},
    { getState },
  ) => {
    const state = getState()
    const finalPermissionKey = permissionKey || state.global.permissionKey
    const { featureTimezone } = selectFeatureTimezone(getState())
    const { data } = await axios.get<ChatterOverviewSales>(
      '/analytics/chatter-overview-sales', {
      params: {
        startAt,
        endAt,
        employeeIds: employeeIds?.join(','),
        groupIds: groupIds?.join(','),
        period,
        responseTimezone: featureTimezone,
        permissionKey: finalPermissionKey,
      },
    })
    return data
  },
)

export const readChatterOverviewComparison = createAppAsyncThunk(
  `${chatterReportsNamespace}/readChatterOverviewComparison`,
  async ({
    startAt,
    endAt,
    period,
    employeeIds,
    groupIds,
    permissionKey,
  }: ReadChatterReportParams, { getState }) => {
    const state = getState()
    const { featureTimezone } = selectFeatureTimezone(state)
    const finalPermissionKey = permissionKey || state.global.permissionKey
    return await axios.get<ChatterOverviewComparison>('/analytics/chatter-overview-comparison', {
      params: {
        startAt,
        endAt,
        period,
        employeeIds: employeeIds?.join(','),
        groupIds: groupIds?.join(','),
        permissionKey: finalPermissionKey,
        responseTimezone: featureTimezone,
      },
    })
  },
)

export interface ReadChatterOverviewStatisticsParams extends ReadChatterReportParams {
  showOnlyChatterRoles?: boolean
}

export const readChatterOverviewStatistics = createAppAsyncThunk(
  `${chatterReportsNamespace}/ChatterOverviewStatistics`,
  async ({
    startAt,
    endAt,
    period,
    employeeIds,
    groupIds,
    permissionKey,
    showOnlyChatterRoles,
  }: ReadChatterOverviewStatisticsParams, { getState }) => {
    const state = getState()
    const { featureTimezone } = selectFeatureTimezone(state)
    const finalPermissionKey = permissionKey || state.global.permissionKey
    return await axios.get<ChatterOverviewStatistics>('/analytics/chatter-overview-statistics', {
      params: {
        startAt,
        endAt,
        period,
        employeeIds: employeeIds?.join(','),
        groupIds: groupIds?.join(','),
        permissionKey: finalPermissionKey,
        responseTimezone: featureTimezone,
        showOnlyChatterRoles,
      },
    })
  },
)

export interface ReadChatterPerformanceParams extends ReadChatterReportParams {
  employeeId: number;
}

export const readChatterPerformance = createAppAsyncThunk(
  `${chatterReportsNamespace}/ChatterPerformance`,
  async ({
    startAt,
    endAt,
    period,
    employeeId,
    permissionKey,
  }: ReadChatterPerformanceParams, { getState }) => {
    const state = getState()
    const { featureTimezone } = selectFeatureTimezone(state)
    const finalPermissionKey = permissionKey || state.global.permissionKey
    return await axios.get<ChatterPerformance>('/analytics/chatter-performance', {
      params: {
        startAt,
        endAt,
        period,
        employeeId: employeeId,
        permissionKey: finalPermissionKey,
        responseTimezone: featureTimezone,
      },
    })
  },
)